import type { LookupUser, LookupUsers } from '@atlassian/ui-modifications-core/types';
import { FieldValueLookupError } from '@atlassian/ui-modifications-core/utils';
import type { UserPickerPublicSetValue } from '@atlassian/jira-ui-modifications-common/src/common/utils/common/fields/user-picker.tsx';
import { singleValueLookup } from '@atlassian/jira-ui-modifications-common/src/common/utils/common/utils/single-value-lookup/index.tsx';

export type UserPickerPublicGetValue = null | {
	accountId: string;
};

export type UserPickerInternalValue =
	| undefined
	| null
	| {
			id: string;
			name: string;
			avatarUrl?: string;
	  };

export const userPickerSetValueTransformer = (
	value: UserPickerPublicSetValue,
	lookupValues?: LookupUsers,
): UserPickerInternalValue => {
	if (value === null) {
		return null;
	}

	const foundValue = singleValueLookup<LookupUser>(value, lookupValues, 'accountId');

	if (!foundValue) {
		throw new FieldValueLookupError();
	}

	return {
		id: foundValue.accountId,
		name: foundValue.name,
		avatarUrl: foundValue.picture,
	};
};

export const userPickerGetValueTransformer = (
	value: UserPickerInternalValue,
): UserPickerPublicGetValue => {
	if (!value) {
		return null;
	}

	const { id: accountId } = value;
	return { accountId };
};
